// Keep in sync with BackofficeMessageTemplateType in pga-backend.
// When a new template type ships, add it here and to MESSAGE_TEMPLATE_TYPE_OPTIONS.
// A queryable server-side list can replace this allowlist in a later iteration.
export const MESSAGE_TEMPLATE_TYPE = {
  BIRTHDAY_GREETING: "BIRTHDAY_GREETING"
} as const;

export type MessageTemplateType = (typeof MESSAGE_TEMPLATE_TYPE)[keyof typeof MESSAGE_TEMPLATE_TYPE];

export const MESSAGE_TEMPLATE_TYPE_OPTIONS: {
  value: MessageTemplateType;
  label: string;
}[] = [{ value: MESSAGE_TEMPLATE_TYPE.BIRTHDAY_GREETING, label: "Birthday Greeting" }];

export const DEFAULT_BIRTHDAY_GREETING_SUBJECT = "Happy Birthday from the PGA Career Services Team!";
